import { CSSProperties } from "react";

export function createStyles<T extends {[key:string]:CSSProperties }>(styles:T){
  return styles
}

export function getPublic (filename:string){
  return process.env.PUBLIC_URL+filename

}

export function assertNotNull (value:any,message:string){

  if (!value)  throw message
  return value
}

export const IS_MOBILE=window.matchMedia("(hover: none)").matches && window.matchMedia("(pointer: coarse)")